import React from 'react';

const Parking = props => (
  <svg width={20} height={20} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.478 19.26H1.869V21h2.609v-1.74ZM16.652 19.26h-2.609V21h2.609v-1.74Z"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.522 19.26v-3.477l-1.74-1.74H2.74L1 15.784v3.478h16.522Z"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.349 9.696h-3.87L2.74 14.044h13.044M1 17.522h3.913M13.607 17.522h3.913M15.348 12.304a5.652 5.652 0 1 0 0-11.304 5.652 5.652 0 0 0 0 11.304Z"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.043 9.696V3.609h1.74c.956 0 1.738.782 1.738 1.739 0 .956-.782 1.739-1.739 1.739h-1.739"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Parking;
